import { createSelector } from '@ngrx/store';

import * as fromReportsFeature from '../reducers';
import * as fromReportsSchoolSearchResults from '../reducers/reports-school-searchresults.reducer';

export const getReportsSchoolSearchState = createSelector(
  fromReportsFeature.getReportsSchoolsState,
  (state: fromReportsFeature.ReportsSchoolsState) => state.search
);
export const getReportsSchoolSearchResultsState = createSelector(
    getReportsSchoolSearchState,
    fromReportsSchoolSearchResults.getReportsSchoolSearchResults
);
